module.exports = __webpack_public_path__ + "assets/img/zbt_2.06eb9af1.png";